import React from 'react';
import styles from './Footer.module.scss';
import Login from '../Login/Login';
import { ReactComponent as Logo } from '../../assets/icons/fa.svg';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        
        <div className={styles.cta}>
          <h2 className={styles.cta__title}>Готовы взять финансы под контроль?</h2>
          <p className={styles.cta__desc}>
            Начните использовать ФА уже сегодня и достигайте своих финансовых целей быстрее.
          </p>
          <Login trigger="Начать бесплатно" triggerClassName={styles.cta__btn} />
        </div>

        <div className={styles.footer__content}>
          <div className={styles.footer__brand}>
          <Logo className={styles.footer__logo} />
            <p className={styles.footer__slogan}>Умный инструмент для осознанного управления капиталом.</p>
          </div>

          <div className={styles.footer__links}>
            <div className={styles.navCol}>
              <span className={styles.navCol__title}>Навигация</span>
              <a href="#features" className={styles.navCol__link}>Возможности</a>
              <a href="#how-it-works" className={styles.navCol__link}>Как это работает</a>
              <a href="#faq" className={styles.navCol__link}>Вопросы</a>
            </div>
            
            <div className={styles.navCol}>
              <span className={styles.navCol__title}>Проект</span>
              <a href="#" className={styles.navCol__link}>GitHub</a>
              <a href="#" className={styles.navCol__link}>Telegram</a>
            </div>
          </div>
        </div>

        <div className={styles.footer__bottom}>
          <span className={styles.footer__copy}>© 2026 ФА. Все права защищены.</span>
          <div className={styles.footer__legal}>
            <a href="#" className={styles.footer__legalLink}>Политика конфиденциальности</a>
            <a href="#" className={styles.footer__legalLink}>Условия использования</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;